import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select, { components } from 'react-select'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'
import { useSelector } from "react-redux"

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import TableControl from "pages/parts/TableControl"

import { PGET, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDate, formatDateBackend, findFromArrayById } from 'helpers/helpers'
import Pagination, { ItemPerPage } from "pages/parts/Pagination"

function Index() {
	const { t } = useTranslation()

	const reduxSettings = useSelector(state => state.settings)
	const reduxAccount = useSelector(state => state.account)

	const filterDataRef = useRef({ posId: '' })

	const date = new Date()
	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]
	const types = [{ "id": 1, "name": t('BY_AMOUNT_OF_SALES') }, { "id": 2, "name": t('BY_GROSS_INCOME') }]

	const [categories, setCategories] = useState([])
	const [categoriesInitial, setCategoriesInitial] = useState([])
	const [organizations, setOrganizations] = useState([])
	const [poses, setPoses] = useState([])
	const [data, setData] = useState([])

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [modalTableControl, setModalTableControl] = useState(false)
	const [ItemsPerPage, setItemsPerPage] = useState(20)
	const [URL, setURL] = useState("");
	const [pageCount, setPageCount] = useState(0)

	const [filterData, setFilterData] = useState({
		startDate: formatDateBackend(new Date(date.getFullYear(), date.getMonth(), 1)),
		endDate: formatDateBackend(new Date()),
		posId: reduxAccount.posId,
		currencyId: reduxSettings?.currencyId ? reduxSettings?.currencyId : 1,
		search: null,
		typeId: 1,
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/report-category-management/' + filterData.typeId + "/" + filterData.currencyId,
		response: null
	})

	async function searchWithFilter(exportToExcel = false, tableSort = "") {
		var filterUrl = "/services/web/api/report-category-management/" + filterData.typeId + "/" + filterData.currencyId
		var urlParams = ""
		checkFilter()

		if (filterDataRef?.current?.posId) {
			urlParams += returnSign(urlParams) + 'posId=' + filterDataRef.current?.posId
			filterDataRef.current = null
		}
		if (filterData?.posId)
			urlParams += returnSign(urlParams) + 'posId=' + filterData?.posId
		if (filterData.organizationId)
			urlParams += returnSign(urlParams) + 'organizationId=' + filterData.organizationId
		if (filterData.productCategoryId)
			urlParams += returnSign(urlParams) + 'productCategoryId=' + filterData.productCategoryId
		if (filterData.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if ("/services/web/api/report-category-management/" + filterData.typeId + "/" + filterData.currencyId + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		if (tableSort) {
			var filterDataCopy = { ...filterData }
			if (filterDataCopy.tableSortKey === tableSort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = tableSort

			setFilterData(filterDataCopy)
			urlParams += returnSign(urlParams) + 'sort=' + tableSort + filterDataCopy.tableSortDirection
		}
		let WithoutParams = filterUrl
		filterUrl = filterUrl + urlParams
		setURL(filterUrl);

		if (exportToExcel) {
			filterUrl = "/services/web/api/report-category-management-excel/" + filterData.typeId + "/" + filterData.currencyId + urlParams + returnSign(filterUrl)

			var excelHeaders = [[t('POS'), t('PRODUCT_ID'), t('NAME_OF_PRODUCT'), t('BARCODE'), t('QUANTITY'), t('AMOUNT'), t('PERCENTAGE')]]
			const response = await GET(filterUrl)
			for (let i = 0; i < response.length; i++) {
				var excelItems = []
				excelItems.push(response[i].posName)
				excelItems.push(response[i].productId)
				excelItems.push(response[i].productName)
				excelItems.push(response[i].productBarcode)
				excelItems.push(response[i].quantity)
				excelItems.push(response[i].totalAmount)
				excelItems.push(response[i].percent)
				excelHeaders.push(excelItems)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('CATEGORY_MANAGEMENT') + ".xlsx");
		} else {
			const response = await PGET(WithoutParams, { ...filterData, size: ItemsPerPage }
				, { loader: true })
			if (response) {
				setData(response.data)
				setPagination({ ...pagination, 'url': filterUrl, 'response': response })
				setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

			}
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		setFilterData({
			startDate: null,
			endDate: null,
			posId: null,
			currencyId: 1,
			search: '',
			typeId: 1,
		})
		setFilterDataExist(false)
		getData()
	}

	async function getData() {
		const response = await PGET("/services/web/api/report-category-management/" + filterData.typeId + "/" + filterData.currencyId, { ...filterData, size: ItemsPerPage }
			, { loader: true })
		if (response) {
			setData(response.data)
			setPagination({ ...pagination, 'url': "/services/web/api/report-category-management/" + filterData.typeId + "/" + filterData.currencyId, 'response': response })
			setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

		}
	}

	async function getCategories() {
		const response = await GET('/services/web/api/product-category-helper')
		var arr = []
		for (let i = 0; i < response.length; i++) {
			response[i]['label'] = ' ' + response[i]['name']
			response[i].child = false;
			if (response[i].parentId !== 0) {
				const index = response.findIndex(x => x.id === response[i].parentId)
				if (index !== -1) {
					response[i].child = true;
					if (response[index].options && response[index].options.length > 0) {
						response[index].options.push(response[i])
					} else {
						response[index].options = [response[i]]
					}
				} else {
					arr.push(response[i])
				}
			} else {
				arr.push(response[i])
			}
		}
		setCategories(arr)
		setCategoriesInitial(response)
	}


	function checkFilter() {
		if (
			filterData.startDate === null &&
			filterData.endDate === null &&
			filterData?.posId === null &&
			filterData.currencyId === 1 &&
			filterData.typeId === 1 &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			setPoses(response)
			setFilterData({ ...filterData, posId: response[0]['id'] })
			// filterDataRef.current.posId = response[0]['id']
			searchWithFilter()
		}
	}

	async function getOrganizations() {
		const response = await GET('/services/web/api/organization-helper')
		if (response) {
			setOrganizations(response)
		}
	}

	async function paginate(data) {
		const response = await PGET(URL, { ...filterData, page: data.selected, size: ItemsPerPage }, { loader: true })
		setFilterData({ ...filterData, page: data.selected })
		setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		setData(response.data);
	}


	useEffect(() => {
		getPoses()
		getCategories()
		getOrganizations()
	}, [ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (filterData.search != null) {
			searchWithFilter(false)
		}
	}, [filterData.search, ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	const GroupHead = props => {
		return (
			<div style={{
				padding: '0',
				color: filterData.productCategoryId === props.data.id ? '#fff' : '#999',
				fontWeight: 'bold',
				backgroundColor: filterData.productCategoryId === props.data.id ? '#2684FF' : '#fff',
				fontSize: '.8rem'
			}}
				onClick={(e) => selectCategory(props.data)}>
				<components.Option {...props} />
			</div>
		);
	};

	const Option = props => {
		return (
			<div style={{
				padding: props.data.child ? '0 0 0 20px' : '0', color: '#999',
				fontWeight: props.data.parentId === 0 ? 'bold' : 'normal', fontSize: '.8rem'
			}}>
				<components.Option {...props} />
			</div>
		);
	};

	async function selectCategory(option) {
		setIsOpen(!isOpen)
		if (option === null) {
			getData()
			setFilterData({ ...filterData, 'productCategoryId': null })
			return
		}
		setFilterData({ ...filterData, 'productCategoryId': option.id })
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('CATEGORY_MANAGEMENT')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}
									disableGroupSearch>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData?.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CURRENCY')}</label>
												<Select
													options={currencies}
													value={currencies.find(option => option.id === filterData.currencyId)}
													onChange={(option) => setFilterData({ ...filterData, 'currencyId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('TYPE')}</label>
												<Select
													options={types}
													value={types.find(option => option.id === filterData.typeId)}
													onChange={(option) => setFilterData({ ...filterData, 'typeId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CATEGORY')}</label>
												<Select
													isClearable
													components={{ GroupHeading: GroupHead, Option }}
													classNamePrefix="react-select"
													options={categories}
													value={categoriesInitial.find(option => option.id === filterData.productCategoryId) || ''}
													onChange={(option) => selectCategory(option)}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.label}
													getOptionValue={(option) => option.id}
													onMenuOpen={() => setIsOpen(true)}
													onBlur={() => setIsOpen(false)}
													menuIsOpen={isOpen}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('SUPPLIER')}</label>
												<Select
													options={organizations}
													value={organizations.find(option => option.id === filterData.organizationId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'organizationId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide" onClick={() => searchWithFilter(true)}>EXCEL</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
										{filterData.organizationId &&
											<span className="me-2">
												<b>{t('ORGANIZATION')}: </b> {findFromArrayById(organizations, filterData.organizationId)}
											</span>
										}
										{filterData.productCategoryId &&
											<span className="me-2">
												<b>{t('CATEGORY')}: </b> {findFromArrayById(categoriesInitial, filterData.productCategoryId)}
											</span>
										}
									</span>
								}
								{filterData?.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData?.posId)}
									</span>
								}
								{filterData.currencyId &&
									<span className="me-2">
										<b>{t('CURRENCY')}: </b> {findFromArrayById(currencies, filterData.currencyId)}
									</span>
								}
								{filterData.currencyId &&
									<span className="me-2">
										<b>{t('TYPE')}: </b> {findFromArrayById(types, filterData.typeId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<ItemPerPage
						itemsPerPage={ItemsPerPage}
						setItemsPerPage={(e) => {
							setItemsPerPage(e); // Update ItemsPerPage
							setFilterData({ ...filterData, page: 0, random: filterData.random + 1 }); // Reset to the first page

						}}
					/>

					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'posName')}>
										{t('POS')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'productName')}>
										{t('NAME_OF_PRODUCT')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productName') && 'sort-active')}></i>
										</div>
									</th>
									{(!reduxSettings.tableReportCategoryManagment || reduxSettings.tableReportCategoryManagment?.categoryName) &&
										<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'categoryName')}>
											{t('CATEGORY')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'categoryName') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'categoryName') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'productBarcode')}>
										{t('BARCODE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productBarcode') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productBarcode') && 'sort-active')}></i>
										</div>
									</th>
									{(!reduxSettings.tableReportCategoryManagment || reduxSettings.tableReportCategoryManagment?.artikul) &&
										<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'productArtikul')}>
											{t('ARTIKUL')}
											<div className="table-sort">
												<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'productArtikul') && 'sort-active')}></i>
												<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'productArtikul') && 'sort-active')}></i>
											</div>
										</th>
									}
									<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'quantity')}>
										{t('QUANTITY')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'quantity') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'quantity') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'totalAmount')}>
										{t('AMOUNT')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'totalAmount') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'totalAmount') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable text-center cursor" onClick={() => searchWithFilter(false, 'percent')}>
										<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
										{t('PERCENTAGE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'percent') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'percent') && 'sort-active')}></i>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td>{item.rowNum}. {item.posName}</td>
										<td>{item.productName}</td>
										{(!reduxSettings.tableReportCategoryManagment || reduxSettings.tableReportCategoryManagment?.categoryName) &&
											<td className="text-center">{item.categoryName}</td>
										}
										<td className="text-center">{item.productBarcode}</td>
										{(!reduxSettings.tableReportCategoryManagment || reduxSettings.tableReportCategoryManagment?.artikul) &&
											<td className="text-center">{item.productArtikul}</td>
										}
										<td className="text-center">{formatMoney(item.quantity)}</td>
										<td className="text-center">{formatMoney(item.totalAmount)}</td>
										<td className="text-center">{item.percent}</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate} reduxPage={filterData.page}></Pagination>

				</div>
			</div>

			{/* MODAL TABLE CONTROL */}
			<TableControl
				modalTableControl={modalTableControl}
				setModalTableControl={setModalTableControl}
				keyName={'tableReportCategoryManagment'}>
			</TableControl>
			{/* MODAL TABLE CONTROL */}
		</>
	)
}

export default Index
